/**
 * Parse a date string from the backend (SQLite datetime) as UTC.
 * SQLite's datetime('now') returns "YYYY-MM-DD HH:MM:SS" without a
 * timezone suffix, which JS interprets as local time. This appends "Z"
 * to force UTC interpretation when no timezone indicator is present.
 */
export function parseUTC(dateStr: string): Date {
  if (dateStr.endsWith("Z") || dateStr.includes("+") || dateStr.includes("T")) {
    return new Date(dateStr);
  }
  return new Date(dateStr + "Z");
}

export function formatDateTime(dateStr: string): string {
  return parseUTC(dateStr).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function formatDate(dateStr: string): string {
  return parseUTC(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
